import { render, staticRenderFns } from "./app-reviews.vue?vue&type=template&id=c41a7f94"
import script from "./app-reviews.js?vue&type=script&lang=js&external"
export * from "./app-reviews.js?vue&type=script&lang=js&external"
import style0 from "./app-reviews.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports